import PropTypes from 'prop-types';

const UserAwardLeftIcon = (props) => {
  const { color, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.08"
        d="M12 8.40271e-07L4.3872 0C1.96422 -2.11824e-07 3.45024e-06 1.96421 3.23841e-06 4.38719L2.12045e-06 6.26647C2.79957 6.39391 5.02974 8.67856 5.02974 11.4783C5.02973 14.278 2.79957 16.5626 2.55514e-07 16.69L0 19.6128C-2.11824e-07 22.0358 1.96422 24 4.3872 24L12 24L12 8.40271e-07Z"
        fill={color}
      />
    </svg>
  );
};

UserAwardLeftIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

UserAwardLeftIcon.defaultProps = {
  color: '#CACACA',
  width: 14,
  height: 24
};

export default UserAwardLeftIcon;
